module.exports = __webpack_public_path__ + "57d444ffdb523aeb046df76bd1abaa72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room10/audio1/pipilotti_yc_audio05.jpg
// module id = 892
// module chunks = 0